import { useTheme, Theme } from '@mui/material/styles';
import React, { useContext } from 'react';
import { INode, INodeProps } from '@/types/node';
import { IContent } from './contract';
import { useNodeProps } from '@/node-editor/hooks';
import { ConferenceContext } from '@/store';
import { Box } from '@mui/material';

interface INodeExtended extends Omit<INode, 'content'> {
  content: IContent;
}

interface IProps extends Omit<INodeProps, 'node'> {
  node: INodeExtended;
}

const useStyles = (
  theme: Theme,
  props: Omit<
    IContent,
    'start' | 'end' | 'title' | 'description' | 'location'
  > & {
    override: Record<string, any>;
  }
) => ({
  root: {
    color: `${theme.palette.primary.contrastText} !important`,
    textTransform: 'uppercase !important',
    ...props.override?.root,
  },
});

/**
 * Embed Node description...
 */
export const Render = ({
  node: {
    id,
    override,
    content: { start, end, label, title, description },
  },
}: IProps) => {
  const theme = useTheme();
  const classes = useStyles(theme, { label, override });
  const { conferenceState } = useContext(ConferenceContext);
  // git tix

  return (
    <div {...useNodeProps(id)}>
      <Box
        title="Add to Calendar"
        // className={clsx(classes.root, 'addeventatc')}
        className="addeventatc"
        sx={{ ...classes.root }}
        color="inherit"
      >
        {label}
        <span className="start">{start}</span>
        <span className="end">{end}</span>
        <span className="timezone">
          {conferenceState.conferenceDetail.timezone}
        </span>
        <span className="title">{title}</span>
        <span className="description">{description}</span>
        <span className="location">{`https://${
          (window as any).location.hostname
        }`}</span>
      </Box>
    </div>
  );
};
